import { render, staticRenderFns } from "./gradingClasswise.vue?vue&type=template&id=c2aff6d0&scoped=true&"
import script from "./gradingClasswise.vue?vue&type=script&lang=js&"
export * from "./gradingClasswise.vue?vue&type=script&lang=js&"
import style0 from "./gradingClasswise.vue?vue&type=style&index=0&id=c2aff6d0&lang=scss&scoped=true&"
import style1 from "./gradingClasswise.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./gradingClasswise.vue?vue&type=style&index=2&id=c2aff6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aff6d0",
  null
  
)

export default component.exports